import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerCommunicationComponent } from './dealer-communication.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DealerNotificationsComponent } from '../dealer/dealer-notifications/dealer-notifications.component';
import { DealerAppointmentsComponent } from '../dealer/dealer-appointments/dealer-appointments.component';
import { DealerConversationsComponent } from '../dealer/dealer-conversations/dealer-conversations.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';

const routes: Routes = [
  { path: '', component: DealerCommunicationComponent,
    children: [
      { path: 'notifications', canActivate: [AuthGuard], component: DealerNotificationsComponent  },
      { path: 'appointments', canActivate: [AuthGuard], component: DealerAppointmentsComponent  },
      { path: 'conversations', canActivate: [AuthGuard], component: DealerConversationsComponent },

      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerCommunicationRoutingModule { }
